module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Bold_1.1fcd9b34.woff";